module.exports = __webpack_public_path__ + "static/assets/cecca243ed5a631f814a28b18c879dd9.jpg";